(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cfb-footer"]) return;
  try {
    
(() => {
  function translateCookieClose() {
    const label = document.querySelector('[data-cfb-cookie-close]')?.dataset.cfbCookieClose;
    const button = document.getElementById('shopify-pc__prefs__header-close');
    if (button && label && button.getAttribute('aria-label') !== label) {
      button.setAttribute('aria-label', label);
    }
  }
  const observer = new MutationObserver((records) => {
    if (records.some((record) => record.addedNodes.length > 0)) translateCookieClose();
  });
  observer.observe(document.body, {childList: true, subtree: true});
  translateCookieClose();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cfb-product"]) return;
  try {
    
function cfbInitProduct(root){root.querySelectorAll('[data-cfb-product]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const select=section.querySelector('[data-variant]');const cut=section.querySelector('[data-cut]');const field=section.querySelector('[data-cut-field]');const button=section.querySelector('[data-add]');function update(){if(!select)return;const option=select.selectedOptions[0];section.querySelector('[data-price]').textContent=option.dataset.price;const compare=section.querySelector('[data-compare]');compare.textContent=option.dataset.compare;compare.hidden=!option.dataset.compare;section.querySelector('[data-unit]').textContent=option.dataset.unit;button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.label;if(cut){const applies=/filete|filetad/i.test(option.textContent);field.hidden=!applies;cut.disabled=!applies;cut.required=applies;}const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);}if(select){select.addEventListener('change',update);update();}});}cfbInitProduct(document);document.addEventListener('shopify:section:load',event=>cfbInitProduct(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
